import { motion } from "framer-motion";
import { FaCubes, FaCoins, FaNewspaper, FaSyncAlt, FaShieldAlt, FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const features = [
  {
    title: "Blockchain Real Estate Tools Coming Soon",
    description: "A suite of real estate–themed blockchain products is in development to reshape property investing.",
    icon: <FaCubes className="w-6 h-6 text-purple-400" />,
  },
  {
    title: "Our Native Token Live",
    description: "$RLCN powers the Real Chain ecosystem and enables seamless participation on Solana.",
    icon: <FaCoins className="w-6 h-6 text-purple-400" />,
  },
  {
    title: "Insights Column",
    description: "Stay updated with expert articles on blockchain, real estate, and market innovation.",
    icon: <FaNewspaper className="w-6 h-6 text-purple-400" />,
  },
  {
    title: "Liquidity and Convertibility",
    description: "Move between fiat, crypto, and $RLCN with full flexibility and low friction.",
    icon: <FaSyncAlt className="w-6 h-6 text-purple-400" />,
  },
  {
    title: "Security and Transparency",
    description: "All transactions are recorded on-chain and verified for trust and accountability.",
    icon: <FaShieldAlt className="w-6 h-6 text-purple-400" />,
  },
];

export default function FeaturesTab() {
  // Initialize the navigate function from React Router
  const navigate = useNavigate();

  return (
    <motion.div
      className="max-w-3xl mx-auto min-h-screen overflow-scroll p-6"
      initial={{ opacity: 0, x: -80 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 80 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {/* Back Button */}
     

      <h2 className="text-2xl md:text-4xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
        App Features
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
        {features?.map((feature, index) => (
          <motion.div
            key={index}
            className="p-4 bg-gray-800 rounded-xl shadow-md hover:shadow-lg transition"
            whileHover={{ scale: 1.05 }}
          >
            <div className="flex gap-4 mb-2">
              {feature?.icon}
              <h3 className="text-lg font-semibold">{feature?.title}</h3>
            </div>
            <p className="text-gray-400 text-sm">{feature?.description}</p>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}